import { render } from "./DesktopMessageFileSelector.vue?vue&type=template&id=136c1bb9&scoped=true&ts=true"
import script from "./DesktopMessageFileSelector.vue?vue&type=script&lang=ts"
export * from "./DesktopMessageFileSelector.vue?vue&type=script&lang=ts"

import "./DesktopMessageFileSelector.vue?vue&type=style&index=0&id=136c1bb9&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-136c1bb9"]])

export default __exports__